import { getWithAuth } from "../helpers/request";

export const USER_ENDPOINTS = {
    USER_INFO: '/api/user'
}

export async function getUserInfo() {
    return await getWithAuth(USER_ENDPOINTS.USER_INFO);
}